import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './BooleanIcon.scss';

/**
 * Display check or cross mark icon base on boolean value with red or green color
 */
const BooleanIcon = ({ value }) => {
  return (
    <i
      className={classNames('boolean-icon', {
        negative: !value,
        'checkmark-circle-outline': value,
        'close-circle-outline': !value,
      })}
    ></i>
  );
};

BooleanIcon.propTypes = {
  value: PropTypes.bool.isRequired,
};
export default BooleanIcon;
